<template>
  <GenericExportColumns
    :show-dialog="showExportDialog"
    :export-keys="exportKeys"
    :export-loading="exportLoading"
    :identifier="caseType"
    dialog-title="Manage Export Columns"
    available-fields-title="Select columns"
    :available-fields-width="'15%'"
    :table-width="'85%'"
    :available-fields-max-height="'630px'"
    cancel-btn-text="Cancel"
    export-btn-text="Export"
    no-fields-message="No fields available"
    no-fields-selected-message="No fields selected"
    select-fields-instruction="Select fields from the left panel to begin"
    instructions-text="← Drag to rearrange headers →"
    :use-local-storage="true"
    storage-key-name="exportColumnSelectedKey"
    @closeExportDialog="cancelExportDialog"
    @exportData="exportData"
    @update:show-dialog="updateShowDialog"
  />
</template>

<script>
import GenericExportColumns from '@/components/common/GenericExportColumns.vue'

export default {
  components: {
    GenericExportColumns
  },
  data() {
    return {
      userOrg: this.$storage.getUniversal('user')
    }
  },
  props: {
    showExportDialog: Boolean,
    exportKeys: Array,
    exportLoading: Boolean,
    caseType: String
  },
  methods: {
    cancelExportDialog() {
      this.$emit('closeExportDialog')
    },
    exportData(selectedKeys) {
      this.$emit('exportData', selectedKeys)
    },
    updateShowDialog(value) {
      // Handle dialog visibility changes if needed
    }
  }
}
</script>
